export default "__VITE_PUBLIC_ASSET__174b4e47__"